import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import MagicLink from "../MagicLink";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import CollectionContainer from "./CollectionContainer";
import { useDispatch, useSelector } from "react-redux";
import previewIcon from "../../../assets/icons/previewIcon.png";
import { message } from "antd";
import { arrayMoveImmutable } from "array-move";
import Modal from "../../CommonV2/Modal";
import BottomNav from "../../Builder/RightContainer/Preview/BottomNav";
import Store from "../../Builder/RightContainer/Preview/Store";
import LinkInBio from "../../Builder/RightContainer/Preview/LinkInBio";
import ProductPage from "../../Builder/RightContainer/Preview/Store/CollectionPage";
import closeIcon from "../../../assets/dashboard/popup-close.png";
import {
    addLinkToStoreSection,
    addLinkToStoreSectionsWrapper,
    addNewLinkWithNewStoreSection
} from "../../../Services/apiServices/linkService";
import ProductsScreen from "./ProductsScreen";
import rightArrow from "../../../assets/icons/mobileIcons/rightArrow.png";
import { duplicateStoreSection, deleteSection, findDiff } from "../../Builder/builderServices/utils";
import {
    setNonStoreSectionsChanged,
    setStoreSectionsChanged,
    closeSectionPickModal,
    setMagicLinkInput,
    openSectionCreateModal,
    closeSectionCreateModal
} from "../../../redux/slice/dashboardSlice";
import AddSection from "../AddSection";
import ShareModal from "../../../components/Wall3/Store/ShareBottomSheet";
import { vibrateDevice } from "../utils";

const SortableList = SortableContainer(({ items }) => {
    const [isMenuOpened, setIsMenuOpened] = useState(-1);

    useEffect(() => {
        const handleClickOutside = () => {
            setIsMenuOpened(-1);
        };
        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div className={styles.collectionsContainer}>
            {items.map((collection, index) => {
                if (collection.isDeleted) return <></>;

                return (
                    <SortableItem
                        key={`item-${index}`}
                        index={index}
                        value={collection}
                        isMenuOpened={isMenuOpened === index}
                        isAnyMenuOpened={isMenuOpened > -1}
                        setIsMenuOpened={() => {
                            setIsMenuOpened(index);
                        }}
                        closeMenu={() => {
                            setIsMenuOpened(-1);
                        }}
                    />
                );
            })}
        </div>
    );
});

const SortableItem = SortableElement(({ value, isAnyMenuOpened, isMenuOpened, setIsMenuOpened, closeMenu }) => (
    <CollectionContainer
        collection={value}
        isAnyMenuOpened={isAnyMenuOpened}
        isMenuOpened={isMenuOpened}
        setIsMenuOpened={setIsMenuOpened}
        closeMenu={closeMenu}
    />
));

const index = () => {
    const dispatch = useDispatch();
    const {
        selectedHeader,
        selectedCollection,
        storeSectionsChanged,
        storeLinksChanged,
        isSectionPickModalOpen,
        magicLinkResponse,
        isSectionDeleteModalOpen,
        isSectionCreateModalOpen
    } = useSelector((state) => state.root.dashboard);
    const [list, setList] = useState(storeSectionsChanged);

    const onSortStart = () => {
        vibrateDevice(80);
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        setList(arrayMoveImmutable(list, oldIndex, newIndex));
        let storeSectionsChangedCopy = [...storeSectionsChanged];
        let tempSortId = storeSectionsChangedCopy[newIndex].sortId;

        if (newIndex > oldIndex) {
            storeSectionsChangedCopy = storeSectionsChangedCopy.map((section, i) => {
                if (i > oldIndex && i <= newIndex) {
                    return {
                        ...section,
                        sortId: storeSectionsChangedCopy[i - 1].sortId
                    };
                }
                return section;
            });
        } else if (oldIndex > newIndex) {
            storeSectionsChangedCopy = storeSectionsChangedCopy.map((section, i) => {
                if (i >= newIndex && i < oldIndex) {
                    return {
                        ...section,
                        sortId: storeSectionsChangedCopy[i + 1].sortId
                    };
                }
                return section;
            });
        }
        storeSectionsChangedCopy[oldIndex] = {
            ...storeSectionsChangedCopy[oldIndex],
            sortId: tempSortId
        };
        const item = storeSectionsChangedCopy.splice(oldIndex, 1)[0];
        storeSectionsChangedCopy.splice(newIndex, 0, item);
        dispatch(setStoreSectionsChanged(storeSectionsChangedCopy));
        findDiff();
    };

    useEffect(() => {
        setList(storeSectionsChanged);
    }, [storeSectionsChanged, storeLinksChanged]);

    return (
        <div className={styles.collectionsSection}>
            <MagicLink screen="Store" />
            <SortableList items={list} onSortStart={onSortStart} onSortEnd={onSortEnd} pressDelay={1000} lockAxis="y" />
            <Modal
                showModal={isSectionPickModalOpen}
                alignItems={"flex-end"}
                onClose={() => {
                    dispatch(closeSectionPickModal(false));
                    dispatch(setMagicLinkInput(""));
                }}
            >
                <div className={styles.sectionsListModal}>
                    <div className={styles.sectionsListHeading}>Add link to Section</div>
                    <div className={styles.sectionsList}>
                        {storeSectionsChanged.map((e, i) => {
                            return (
                                <div
                                    className={styles.sectionsListItem}
                                    key={i}
                                    onClick={() => addLinkToStoreSection(e, magicLinkResponse)}
                                >
                                    <div className={styles.sectionsListItemTitle} key={i}>
                                        {e?.title}
                                    </div>
                                    <img className={styles.sectionsListItemArrow} src={rightArrow}></img>
                                </div>
                            );
                        })}
                    </div>
                    <div
                        className={styles.addSection}
                        onClick={() => {
                            dispatch(openSectionCreateModal());
                        }}
                    >
                        {"+ Add Section"}
                    </div>
                </div>
            </Modal>

            {isSectionCreateModalOpen && (
                <AddSection
                    onClose={() => {
                        dispatch(closeSectionCreateModal());
                    }}
                    onConfirm={(title) => {
                        if (title.length > 0) {
                            addNewLinkWithNewStoreSection(title);

                            message.success("Added link to New Section");
                        } else {
                            message.info("Section Title is empty");
                        }
                        dispatch(closeSectionCreateModal());
                    }}
                />
            )}

            <ShareModal />
        </div>
    );
};

export default index;
